<template>
  <el-dialog title="公司付款配置" :visible.sync="visible" width="860px" top="4vh" append-to-body :close-on-click-modal="false" @closed="clear">
    <div v-loading="loading" class="payment-company">
      <p class="intro">管理员：{{ admin.username }}。适用 APP 自动使用该管理员已有的 APP 授权，无需重复选择。</p>
      <el-form label-width="120px" :model="company">
        <el-form-item label="公司全称" required><el-input v-model.trim="company.company_name" maxlength="128" /></el-form-item>
        <el-form-item label="启用付款公司"><el-switch v-model="company.status" :active-value="1" :inactive-value="0" /></el-form-item>
        <el-form-item><el-button type="primary" :loading="saving" @click="saveCompany">保存公司配置</el-button></el-form-item>
      </el-form>

      <template v-if="company.id">
        <div class="section-top"><strong>付款账户</strong><div><el-button size="small" @click="editMerchant('alipay')">新增支付宝</el-button><el-button size="small" @click="editMerchant('wechat')">新增微信</el-button></div></div>
        <p class="hint">每个渠道最新新增的配置用于新提现。停用最新配置后不回退旧账户；已有订单继续绑定原账户。</p>
        <div v-for="item in merchants" :key="item.id" class="merchant-card">
          <div><strong>{{ item.provider === 'wechat' ? '微信 · 旧版转账到零钱' : '支付宝 · 单笔转账' }}</strong>
            <el-tag size="mini" :type="item.enabled ? 'success' : 'info'">{{ item.enabled ? '启用' : '停用' }}</el-tag></div>
          <div class="merchant-detail">配置 #{{ item.id }} · {{ item.mch_id || item.app_id }} · 证书到期 {{ item.certificate_expires_at.slice(0, 10) }}</div>
          <el-button size="mini" @click="editMerchant(item.provider, item)">更新证书</el-button>
          <el-button size="mini" :type="item.enabled ? 'danger' : 'success'" :loading="saving" @click="toggleMerchant(item)">{{ item.enabled ? '停用' : '启用' }}</el-button>
        </div>

        <el-form v-if="editor" :key="editorKey" :model="editor" label-width="155px" class="merchant-editor">
          <h4>{{ editor.id ? '更新证书' : '新增付款账户' }} · {{ editor.provider === 'wechat' ? '微信' : '支付宝' }}</h4>
          <el-form-item v-if="editor.provider === 'alipay'" label="支付宝 APPID" required><el-input v-model.trim="editor.app_id" :disabled="!!editor.id" /></el-form-item>
          <template v-else>
            <el-form-item label="微信商户号" required><el-input v-model.trim="editor.mch_id" :disabled="!!editor.id" /></el-form-item>
            <el-form-item label="微信支付公钥 ID"><el-input v-model.trim="editor.platform_key_id" placeholder="使用平台证书时可留空" /></el-form-item>
            <el-form-item label="APIv3密钥"><el-input v-model="editor.api_v3_key" type="password" autocomplete="new-password" placeholder="可选；留空保留原值" /></el-form-item>
            <p class="hint">转账 APPID 使用各 APP 的微信登录配置，需在此商户号下完成绑定。此配置只适用于仍有旧版转账权限的商户。</p>
          </template>
          <p v-if="editor.provider === 'alipay'" class="hint">应用私钥可直接选择支付宝密钥工具导出的 .txt（PKCS1 / PKCS8），无需改后缀。应用公钥证书请上传开放平台下载的 .crt，不能用工具生成的应用公钥.txt 代替。</p>
          <el-form-item v-for="field in fileFields" :key="field.key" :label="field.label" :required="!editor.id && field.required">
            <input type="file" accept=".pem,.crt,.txt" :aria-label="field.label" @change="selectFile(field.key, $event)" />
          </el-form-item>
          <p class="hint">每个文件不超过64KB。更新时未选择的文件保留原值。私钥和证书加密保存，不提供下载；更换商户号或支付宝 APPID 请新增账户。</p>
          <el-form-item label="启用此付款账户"><el-switch v-model="editor.enabled" :active-value="1" :inactive-value="0" /></el-form-item>
          <el-form-item><el-button type="primary" :loading="saving" @click="saveMerchant">校验并保存</el-button><el-button @click="editor = null; files = {}">取消</el-button></el-form-item>
        </el-form>
      </template>
    </div>
    <span slot="footer"><el-button @click="visible = false">关闭</el-button></span>
  </el-dialog>
</template>

<script>
import axios from '@/network/reuset';
export default {
  data() {
    return { visible: false, loading: false, saving: false, admin: {}, company: {}, merchants: [], editor: null, editorKey: 0, files: {} };
  },
  computed: {
    fileFields() {
      const base = [{ key: 'private_key', label: '应用/商户私钥', required: true }];
      return this.editor.provider === 'alipay' ? base.concat([
        { key: 'app_cert', label: '应用公钥证书', required: true }, { key: 'alipay_cert', label: '支付宝公钥证书', required: true },
        { key: 'alipay_root_cert', label: '支付宝根证书', required: true },
      ]) : base.concat([
        { key: 'merchant_cert', label: '商户 API 证书', required: true }, { key: 'platform_cert', label: '微信支付平台证书' },
        { key: 'platform_public_key', label: '微信支付公钥（可选）' },
      ]);
    },
  },
  methods: {
    async open(admin) { this.clear(); this.admin = admin; this.visible = true; await this.load(); },
    clear() { this.editor = null; this.files = {}; this.company = { company_name: '', status: 1 }; this.merchants = []; },
    async load() {
      this.loading = true;
      try {
        const response = await axios.post('/api/admin/payouts/company/info', { admin_user_id: this.admin.id });
        if (response && response.code === 200) {
          this.company = response.data.company || { company_name: '', status: 1 };
          this.merchants = response.data.merchants;
        }
      } finally { this.loading = false; }
    },
    async saveCompany() {
      if (!this.company.company_name) return this.$message.warning('请填写公司全称');
      this.saving = true;
      try {
        const response = await axios.post('/api/admin/payouts/company/save', { admin_user_id: this.admin.id, company_name: this.company.company_name, status: this.company.status });
        if (response && response.code === 200) { await this.load(); this.$message.success('公司配置已保存'); }
      } finally { this.saving = false; }
    },
    editMerchant(provider, current = {}) {
      this.files = {}; this.editorKey += 1;
      this.editor = { id: current.id || '', provider, app_id: current.app_id || '', mch_id: current.mch_id || '', platform_key_id: current.platform_key_id || '', api_v3_key: '', enabled: current.enabled || 0 };
    },
    selectFile(key, event) {
      const file = event.target.files[0];
      if (file && file.size > 64 * 1024) { event.target.value = ''; this.$delete(this.files, key); return this.$message.warning('每个证书文件不超过64KB'); }
      if (file) this.$set(this.files, key, file); else this.$delete(this.files, key);
    },
    async saveMerchant() {
      this.saving = true;
      try {
        const form = new FormData();
        Object.entries({ ...this.editor, company_id: this.company.id }).forEach(([key, value]) => form.append(key, value));
        Object.entries(this.files).forEach(([key, value]) => form.append(key, value));
        const response = await axios.post('/api/admin/payouts/company/merchant_save', form, { timeout: 30000 });
        if (response && response.code === 200) { this.editor = null; this.files = {}; await this.load(); this.$message.success('付款配置已保存'); }
      } finally { this.saving = false; }
    },
    async toggleMerchant(item) {
      try { await this.$confirm(`${item.enabled ? '停用后将阻止尚未发起的转账，已发起订单仍继续查单。' : '启用前请确认商户权限、APPID绑定和证书正确。'}确认继续？`, '付款账户状态'); }
      catch (_) { return; }
      this.saving = true;
      try {
        const response = await axios.post('/api/admin/payouts/company/merchant_enabled', { id: item.id, enabled: item.enabled ? 0 : 1 });
        if (response && response.code === 200) await this.load();
      } finally { this.saving = false; }
    },
  },
};
</script>

<style scoped>
.payment-company { max-height: calc(88vh - 180px); overflow-y: auto; padding-right: 12px; }
.intro { margin-top: 0; color: #303133; line-height: 1.7; }
.hint { font-size: 12px; color: #606266; line-height: 1.7; margin: 8px 0; }
.section-top { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.merchant-card { border: 1px solid #dcdfe6; border-radius: 4px; padding: 14px; margin: 12px 0; }
.merchant-card .el-tag { margin-left: 12px; }
.merchant-detail { color: #606266; margin: 10px 0; overflow-wrap: anywhere; }
.merchant-editor { border-top: 1px solid #dcdfe6; margin-top: 20px; padding-top: 4px; }
input[type=file] { max-width: 100%; }
@media (max-width: 600px) { .section-top { flex-wrap: wrap; } .payment-company { padding-right: 0; } }
</style>
